import React from 'react';

import './FeatureImage.css';

const FeatureImage = ({ src, srcSet = null, children, customClass = '', url = null }) => {
  const img = <img src={src} alt="featureImage" srcSet={srcSet} className={`featureImageItem ${customClass}`} />;
  return (
    <div className="featureImage">
      {children}
      {url ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {img}
        </a>
      ) : (
        img
      )}
    </div>
  );
};

export default FeatureImage;
